import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { CheckoutTemplate } from '@components/templates/Checkout';
import { DownloadPage } from '@pages/Download';
import { GenericErrorPage } from '@pages/Error';
import { NotFoundPage } from '@pages/NotFound';
import { PaymentPage } from '@pages/Payment';
import { PaymentLink } from '@pages/PaymentLink';
import { PaymentStatusPage } from '@pages/PaymentStatus';

import { ROUTES } from './paths';

export default function AppRoutes() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path={ROUTES.HOME} element={<DownloadPage />} />
        <Route path={ROUTES.CHECKOUT} element={<DownloadPage />} />

        <Route element={<CheckoutTemplate />}>
          <Route path={ROUTES.PAYMENT} element={<PaymentPage />} />
          <Route path={ROUTES.PAYMENT_STATUS} element={<PaymentStatusPage />} />
          <Route path={ROUTES.PAYMENT_LINK} element={<PaymentLink />} />
        </Route>

        <Route path={ROUTES.GENERIC_ERROR} element={<GenericErrorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
